import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
import { userActionCreators } from '../../data/user/userActions';
import { UserState } from '../../data/user/userModels';
/*import { CustomerData } from '../../data/apiClient/client';*/
/* tslint:disable */
interface HomeState {
    header: HeaderState;
    user: UserState;
    opportunityLoading: boolean;
    ordersLoading: boolean;
    invoiceLoading: boolean;
    shipmentLoading: boolean;
}

interface HomeActions {
    headerActions: typeof headerActionCreators;
    userActions: typeof userActionCreators;
}

type MenuBarProps = HomeState & // ... state we've requested from the Redux store
    HomeActions & // ... plus action creators we've requested
    RouteComponentProps<{}>; // ... plus incoming routing parameters

class MenuBar extends React.Component<MenuBarProps, {}> {
    constructor(props: MenuBarProps) {
        super(props);
        this.state = {
            popoverOpen: false
        };
    }

    public render() {
        return this.props.user.error && this.props.user.error === true ? (
            <div />
        ) : (
            <div className="container-fluid menupadding">
                <div className="menuBar">
                    <nav className="nav justify-content-end">
                        <li className="nav-item">
                            <NavLink exact={true} to={'/'} className="navLink">
                                Home
                            </NavLink>
                        </li>
                        {this.props.user.permissions.opportunities.read !== undefined &&
                        this.props.user.permissions.opportunities.read === true ? (
                            <li className="nav-item">
                                |
                                <NavLink exact={true} to={'/opportunities'} className="navLink">
                                    Opportunities
                                </NavLink>
                            </li>
                        ) : null}
                        {this.props.user.permissions.duct.read !== undefined &&
                        this.props.user.permissions.duct.read === true ? (
                            <li className="nav-item">
                                |
                                <NavLink exact={true} to={'/ductdesign'} className="navLink">
                                    Duct Design
                                </NavLink>
                            </li>
                        ) : null}
                        {this.props.user.permissions.orders.read !== undefined &&
                        this.props.user.permissions.orders.read === true ? (
                            <li className="nav-item">
                                |
                                <NavLink exact={true} to={'/orders'} className="navLink">
                                    Orders
                                </NavLink>
                            </li>
                        ) : null}
                        {this.props.user.permissions.orders.read !== undefined &&
                        this.props.user.permissions.orders.read === true ? (
                            <li className="nav-item">
                                |
                                <NavLink exact={true} to={'/shipments'} className="navLink">
                                    Shipments
                                </NavLink>
                            </li>
                        ) : null}
                        {this.props.user.permissions.invoices.read !== undefined &&
                        this.props.user.permissions.invoices.read === true ? (
                            <li className="nav-item">
                                |
                                <NavLink exact={true} to={'/invoices'} className="navLink">
                                    Invoices
                                </NavLink>
                            </li>
                        ) : null}
                        |
                        <li className="nav-item">
                            <NavLink exact={true} to={'/internalnews'} className="navLink">
                                Nordfab Dealer News
                            </NavLink>
                        </li>
                        |
                        <li className="nav-item">
                            <a className="navLink" target="_blank" href="https://www.nordfab.com/en-us/latest-news">
                                News
                            </a>
                        </li>
                        |
                        <li className="nav-item bold">
                            <NavLink exact={true} to={'/search'} className="navLink">
                                Search <i className="fa fa-search"></i>
                            </NavLink>
                        </li>
                    </nav>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): HomeState {
    return {
        header: state.header,
        user: state.user,
        opportunityLoading: state.opportunities.loading,
        invoiceLoading: state.invoices.loading,
        ordersLoading: state.order.loading,
        shipmentLoading: state.shipments.loading
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): HomeActions {
    return {
        headerActions: bindActionCreators(headerActionCreators, dispatch),
        userActions: bindActionCreators(userActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(MenuBar)
);



// WEBPACK FOOTER //
// ./src/containers/menubar/menubar.tsx